import { useQuery } from 'react-query';

import {
  TournamentByeResponse,
  TournamentByes,
} from '~/../api/common.types';
import { api } from '~/client/api';

export const useGetTournamentByes = ({
  data,
}: {
  data: TournamentByes;
}) => {
  return useQuery<TournamentByeResponse | undefined, Error>(
    ['tournament-byes', data, data.contextId],
    () => api.getTournamentByes(data),
  );
};
